/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import moment from 'moment';
import React, { PureComponent } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown, PopoverHeader, UncontrolledPopover,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import {
  allocateProducts, getDataGrid, getDataGridIds,
} from '../../../app/store/actions/outboundPendingAllocationMonitor';
import Permissions from '../../../app/services/permissions';
import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';
import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';
import FormatHelpers from '../../../helpers/format';
import ModalAllocationFailureReason from './modalAllocationFailureReason';
import 'react-datepicker/dist/react-datepicker.css';

export class List extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      orderList: [],
      productList: [],
      selectedAllocations: {},
      selectedIds: [],
      startDate: moment().subtract(30, 'days'),
      endDate: moment(),
      showModalPendingAllocation: false,
      showModalAllocationFailure: false,
      allocationFailureResult: null,
      isSimulationAllocation: false,
      date: '',
      pages: 0,
      totalDataLength: 0,
      loading: false,
    };

    // Estado da grid enviado ao servidor a cada consulta (a tela deixou de
    // trazer tudo e paginar em memoria).
    this.page = 0;
    this.pageSize = 5;
    this.sorted = [{ id: 'orderNumber', desc: false }];
    this.filtered = [];

    this.defaultSorted = [
      {
        id: 'orderNumber',
        desc: false,
      },
    ];

    this.defaultSortedProducts = [
      {
        id: 'lineNumber',
        desc: false,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE436' /* Selecionar */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            {(row.original.status !== 200) && (
              <input
                type="checkbox"
                checked={this.state.selectedAllocations[row.original.id] || false}
                onChange={() => this.singleSelection(row.original.id)}
              />
            )}
          </div>
        ),
      }, {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="btn btn-default btn-xs"
            >
              {I18n.t('BEE55' /* Ações */)}
            </button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={() => this.allocateOrder(row.original.id)}>
                  {I18n.t('BEE3198' /* Alocar Produtos */)}
                </DropdownItem>
                {!Permissions.checkPermission(ROUTES.P_SIMULATE_ALLOCATION) && (
                  <DropdownItem onClick={() => this.allocateOrder(row.original.id, true)}>
                    {`${I18n.t('BEE600' /* Simular */)} - ${I18n.t('BEE3198' /* Alocar Produtos */)}`}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE1378' /* Documento */),
        accessor: 'orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4526' /* Carga */),
        accessor: 'load.loadNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE3351' /* Alocação Prevista (%) */),
        accessor: 'percentageAllocation',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 160,
        // Calculada no servidor a partir dos produtos, do saldo e do
        // crossdocking: nao existe coluna para filtrar. A ordenacao so
        // percorre a base inteira quando o cliente clica nesta coluna.
        filterable: false,
        defaultSortDesc: true,
      }, {
        Header: I18n.t('BEE1096' /* Pedido cliente */),
        accessor: 'customerOrderCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE50' /* Cliente */),
        accessor: 'customerName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE51' /* Pedido */),
        accessor: 'erpOrderCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'orderType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4115' /* Prioridade */),
        accessor: 'priority.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      },
      {
        Header: 'Data Documento',
        accessor: 'orderDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE444' /* Data de Entrega */),
        accessor: 'deliveryDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        Filter: this.filterDeliveryDate,
        filterMethod: (filter, row) => {
          const input = filter.value !== null ? _.lowerCase(moment(filter.value).format('L')) : '';
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE1057' /* Entrega */),
        accessor: 'deliveryType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE301' /* Transportadora */),
        accessor: 'carrierName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
      },
    ];

    this.productTableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="btn btn-default btn-xs"
            >
              {I18n.t('BEE55' /* Ações */)}
            </button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                {row.original.status === 1
                  && (
                  <DropdownItem onClick={() => this.allocateProduct(row.original.id)}>
                    {I18n.t('BEE4736' /* Alocar Produto */)}
                  </DropdownItem>
                  )}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE463' /* Linha */),
        accessor: 'lineNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
        Cell: (row) => {
          const isRedLine = (parseFloat(row.original.available || 0) + parseFloat(row.original.allocatedQuantity))
            < parseFloat(row.original.quantity);
          return this.renderPopoverForRedLine(
            row.value,
            row.original.id,
            'lineNumber',
            isRedLine,
          );
        },
      }, {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        Cell: (row) => {
          const isRedLine = (parseFloat(row.original.available || 0) + parseFloat(row.original.allocatedQuantity))
            < parseFloat(row.original.quantity);
          return this.renderPopoverForRedLine(
            row.value,
            row.original.id,
            'productCode',
            isRedLine,
          );
        },
      }, {
        Header: I18n.t('BEE1897' /* Descrição */),
        accessor: 'product.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
        Filter: this.filterColumn,
        Cell: (row) => {
          const isRedLine = (parseFloat(row.original.available || 0) + parseFloat(row.original.allocatedQuantity))
            < parseFloat(row.original.quantity);
          return this.renderPopoverForRedLine(
            row.value,
            row.original.id,
            'productName',
            isRedLine,
          );
        },
      }, {
        Header: I18n.t('BEE384' /* Unidade */),
        accessor: 'product.unitMeasure',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
        Cell: (row) => {
          const isRedLine = (parseFloat(row.original.available || 0) + parseFloat(row.original.allocatedQuantity))
            < parseFloat(row.original.quantity);
          return this.renderPopoverForRedLine(
            row.value,
            row.original.id,
            'productUnitMeasure',
            isRedLine,
          );
        },
      }, {
        Header: I18n.t('BEE441' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
        Filter: this.filterColumn,
        Cell: (row) => {
          const isRedLine = (parseFloat(row.original.available || 0) + parseFloat(row.original.allocatedQuantity))
            < parseFloat(row.original.quantity);
          return this.renderPopoverForRedLine(
            FormatHelpers.formatNumber(row.value || 0, 4),
            row.original.id,
            'quantity',
            isRedLine,
          );
        },
      }, {
        Header: I18n.t('BEE1431' /* Alocado */),
        accessor: 'allocatedQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
        Filter: this.filterColumn,
        Cell: (row) => {
          const isRedLine = (parseFloat(row.original.available || 0) + parseFloat(row.original.allocatedQuantity))
            < parseFloat(row.original.quantity);
          return this.renderPopoverForRedLine(
            FormatHelpers.formatNumber(row.value || 0, 4),
            row.original.id,
            'allocatedQty',
            isRedLine,
          );
        },
      },
      {
        Header: I18n.t('BEE530' /* Disponível */),
        accessor: 'available',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
        Filter: this.filterColumn,
        Cell: (row) => {
          const isRedLine = (parseFloat(row.original.available || 0) + parseFloat(row.original.allocatedQuantity))
            < parseFloat(row.original.quantity);
          return this.renderPopoverForRedLine(
            FormatHelpers.formatNumber(row.value || 0, 4),
            row.original.id,
            'available',
            isRedLine,
          );
        },
      },
    ];
  }

  componentDidMount() {
    // A primeira carga vem do onFetchData da grid (paginacao no servidor):
    // chamar aqui tambem faria duas consultas ao abrir a tela.
  }

  handleDateChange = (date) => {
    this.setState({ date });
  };

  filterDeliveryDate = ({ onChange }) => (
    <DatePicker
      selected={this.state.date}
      onChange={(date) => {
        this.handleDateChange(date);
        onChange(date);
      }}
      dateFormat="dd/MM/yyyy"
      withPortal
      isClearable
    />
  );

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  renderPopoverForRedLine = (value, rowId, uniqueId, isRedLine) => (
    <span>
      {isRedLine && (
        <UncontrolledPopover
          trigger="hover"
          placement="top-start"
          target={`popoverbadline${uniqueId}${rowId}`}
        >
          <PopoverHeader>
            {I18n.t('BEE4625' /* Linhas em vermelho indicam itens sem saldo disponível suficiente para alocação. */)}
          </PopoverHeader>
        </UncontrolledPopover>
      )}
      <span id={`popoverbadline${uniqueId}${rowId}`}>
        {value}
      </span>
    </span>
  );

  buildTableParams = () => ({
    startDate: moment(this.state.startDate).format(),
    endDate: moment(this.state.endDate).format(),
    status: 1,
    page: this.page,
    pageSize: this.pageSize,
    sorted: this.sorted,
    filtered: this.filtered,
  });

  getDataGrid = async () => {
    this.setState({ loading: true });

    try {
      const list = await this.props.getDataGrid(this.buildTableParams());

      this.setState({
        orderList: list ? list.rows : [],
        pages: list ? list.pages : 0,
        totalDataLength: list ? list.totalDataLength : 0,
        productList: [],
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  setOrderSelected = (order) => {
    this.setState({
      orderSelect: order,
      productList: order.products,
    });
  };

  showModalAllocationFailure = (allocationFailureResult, isSimulationAllocation = false) => {
    this.setState({
      showModalAllocationFailure: true,
      allocationFailureResult,
      isSimulationAllocation,
    });
  };

  closeModalAllocationFailureReason = () => {
    this.setState({
      showModalAllocationFailure: false,
      allocationFailureResult: null,
      isSimulationAllocation: false,
    });
  };

  hasAllocationFailureReason = (result) => result && result.reason;

  parseAllocationFailureResponse = (payload) => {
    if (!payload) return null;

    if (payload.reason || payload.allocationPossible === false || payload.failures) {
      return payload;
    }

    if (payload.data && (
      payload.data.reason
      || payload.data.allocationPossible === false
      || payload.data.failures
    )) {
      return payload.data;
    }

    return null;
  };

  enrichAllocationResult = (result, orderSelect) => {
    if (!result) return result;

    return {
      ...result,
      orderNumber: result.orderNumber
        || (orderSelect && orderSelect.orderNumber)
        || _.get(result, 'failures[0].orderNumber'),
    };
  };

  handleAllocationResult = (result, isSimulation, options = {}) => {
    const {
      successMessage = I18n.t('BEE2985' /* Produto alocado com sucesso! */),
      failMessage = I18n.t('BEE4704' /* Não foi possível alocar o produto selecionado. */),
      partialMessage,
      refreshOnSuccess = true,
      clearSelection = false,
    } = options;

    if (result && result.success === false) {
      addNotification(
        'danger',
        I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
        failMessage,
        'top-right',
      );
      return;
    }

    const hasReason = this.hasAllocationFailureReason(result);
    const isAllocationFailure = result
     && (
       result.allocationPossible === false
    || ((result.amountSuccess || 0) === 0 && (result.amountFail || 0) > 0)
     );
    if (hasReason) {
      this.showModalAllocationFailure(result, isSimulation);
    }

    if (isAllocationFailure) {
      if (!hasReason) {
        addNotification(
          'danger',
          I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
          failMessage,
          'top-right',
        );
      }
      return;
    }

    if (clearSelection) {
      this.setState({
        selectedAllocations: {},
        selectedIds: [],
      });
    }

    if (isSimulation) {
      return;
    }

    const hasPartialFailure = result && (result.amountFail || 0) > 0;

    addNotification(
      hasPartialFailure ? 'warning' : 'success',
      I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
      partialMessage || successMessage,
      'top-right',
    );

    if (refreshOnSuccess) {
      this.getDataGrid();
    }
  };

  allocateProduct = async (outboundProductId, isSimulation = false) => {
    const { orderSelect } = this.state;
    const outboundOrderId = orderSelect && orderSelect.id;

    if (!outboundOrderId) {
      addNotification(
        'danger',
        I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
        I18n.t('BEE4708' /* Selecione um documento antes de alocar o produto. */),
        'top-right',
      );
      return;
    }

    const allocationOptions = {
      successMessage: isSimulation
        ? I18n.t('BEE4702' /* Simulação de alocação concluída com sucesso! */)
        : I18n.t('BEE2985' /* Produto alocado com sucesso! */),
      failMessage: isSimulation
        ? I18n.t('BEE4703' /* Não foi possível simular a alocação do produto selecionado. */)
        : I18n.t('BEE4704' /* Não foi possível alocar o produto selecionado. */),
      refreshOnSuccess: !isSimulation,
    };

    try {
      const result = await this.props.allocateProducts(outboundOrderId, outboundProductId, isSimulation);

      this.handleAllocationResult(
        this.enrichAllocationResult(result, orderSelect),
        isSimulation,
        allocationOptions,
      );
    } catch (err) {
      const responseData = err.response && err.response.data;
      const allocationResult = this.parseAllocationFailureResponse(responseData);

      if (allocationResult) {
        this.handleAllocationResult(
          this.enrichAllocationResult(allocationResult, orderSelect),
          isSimulation,
          allocationOptions,
        );
        return;
      }

      const error = responseData && responseData.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification(
          'danger',
          I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
          isSimulation
            ? I18n.t('BEE4709' /* Erro ao tentar simular a alocação do Produto selecionado */)
            : I18n.t('BEE4710' /* Erro ao tentar alocar o Produto selecionado */),
          'top-right',
        );
      }
    }
  };

  allocateOrder = async (outboundOrderId, isSimulation = false) => {
    try {
      this.setState({
        showModalPendingAllocation: false,
      });

      const result = await this.props.allocateProducts(outboundOrderId, null, isSimulation);

      this.handleAllocationResult(result, isSimulation, {
        successMessage: isSimulation
          ? I18n.t('BEE4702' /* Simulação de alocação concluída com sucesso! */)
          : undefined,
        failMessage: isSimulation
          ? I18n.t('BEE4705' /* Não foi possível simular a alocação do Documento selecionado */)
          : I18n.t('BEE4706' /* Não foi possível alocar todo o documento selecionado. */),
        partialMessage: `${I18n.t('BEE2934', { /* De %{0} documentos selecionados, %{1} alocados e %{2} não alocados. */
          0: result.amountTotal,
          1: result.amountSuccess,
          2: result.amountFail,
        })}${
          result.cableCutPlanCreated ? ` ${I18n.t('BEE4120' /* Plano de Corte gerado com sucesso! */)}` : ''
        }`,
        clearSelection: true,
        refreshOnSuccess: !isSimulation,
      });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification(
          'danger',
          I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
          I18n.t('BEE4707' /* Erro ao tentar alocar o Documento selecionado */),
          'top-right',
        );
      }
    }
  };

  singleSelection = (idAllocation) => {
    this.setState((prevState) => {
      const { selectedAllocations } = prevState;
      return {
        selectedAllocations: {
          ...selectedAllocations,
          [idAllocation]: !selectedAllocations[idAllocation],
        },
      };
    });
  };

  multipleSelection = async (selectionOption) => {
    if (!selectionOption) {
      this.setState({ selectedAllocations: {}, selectedIds: [] });
      return;
    }

    // A grid so tem a pagina atual: os documentos do filtro vem do servidor
    // para o botao continuar marcando a base inteira, como antes.
    const result = await this.props.getDataGridIds(this.buildTableParams());
    const ids = (result && result.ids) || [];

    const updatedSelectedAllocations = {};
    for (const id of ids) {
      updatedSelectedAllocations[id] = true;
    }

    this.setState((prevState) => ({
      selectedAllocations: { ...prevState.selectedAllocations, ...updatedSelectedAllocations },
    }));
  };

  validChecked = () => {
    const { selectedAllocations } = this.state;
    if (!Object.keys(selectedAllocations).length) {
      addNotification(
        'danger',
        I18n.t('BEE2223' /* Monitor de Integração */),
        I18n.t('BEE2236' /* Nenhuma integração selecionada */),
        'top-right',
      );
    } else {
      const selectedIds = [];
      for (const index in selectedAllocations) {
        if (selectedAllocations[index]) selectedIds.push(index);
      }
      if (selectedIds.length) {
        this.setState({
          selectedIds: [...selectedIds],
          showModalPendingAllocation: true,
        });
      } else {
        addNotification(
          'danger',
          I18n.t('BEE2223' /* Monitor de Integração */),
          I18n.t('BEE2236' /* Nenhuma integração selecionada */),
          'top-right',
        );
      }
    }
  };

  handleDateApplyEvent = async (event) => {
    const startDate = moment(event[0]);
    const endDate = moment(event[1]);

    await this.setState({
      startDate,
      endDate,
    });

    this.page = 0;

    // Trocar o periodo com a grid numa pagina do meio pediria ao servidor uma
    // pagina que o novo filtro pode nem ter. Voltar para a primeira ja dispara
    // o onFetchData; so quando ela ja e a atual e preciso consultar na mao.
    if (this.tableComponent && this.tableComponent.state.page !== 0) {
      this.tableComponent.handlePageChange(0);
    } else {
      this.getDataGrid();
    }
  };

  render() {
    const {
      orderList, productList, orderSelect, selectedIds,
      showModalPendingAllocation, showModalAllocationFailure,
      allocationFailureResult, isSimulationAllocation,
      pages, totalDataLength, loading,
    } = this.state;

    return (
      <div>
        <Table
          panelHeaderProps={{
            onClickReload: this.getDataGrid,
            children: I18n.t('BEE462' /* Documentos */).toUpperCase(),
          }}
          filterable
          data={orderList}
          columns={this.tableColumns}
          expander
          defaultPageSize={5}
          defaultSorted={this.defaultSorted}
          manual
          pages={pages}
          loading={loading}
          totalDataLength={totalDataLength}
          onFetchData={(state) => {
            this.page = state.page;
            this.pageSize = state.pageSize;
            this.sorted = state.sorted;
            this.filtered = state.filtered;
            this.getDataGrid();
          }}
          datePicker={{
            handleDateApplyEvent: this.handleDateApplyEvent,
          }}
          actionButtons={(
            <div className="ml-auto -my-5">
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-5"
                onClick={() => this.multipleSelection(true)}
              >
                {I18n.t('BEE1908' /* Marcar Todos */)}
              </button>
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-5"
                onClick={() => this.multipleSelection(false)}
              >
                {I18n.t('BEE1909' /* Desmarcar Todos */)}
              </button>
              <OneClickButton
                type="button"
                className="btn btn-140 btn-primary p-5 m-5"
                onClick={() => this.validChecked()}
              >
                {I18n.t('BEE2956' /* Alocação automática */)}
              </OneClickButton>
            </div>
          )}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: () => {
                  this.setOrderSelected(rowInfo.original);
                },
                style: {
                  background: orderSelect && rowInfo.original.id === orderSelect.id ? 'silver' : 'white',
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
          ref={(r) => {
            this.tableComponent = r;
          }}
        />

        <Table
          panelHeaderProps={{
            children: I18n.t('BEE27' /* Produtos */).toUpperCase(),
          }}
          filterable
          data={productList}
          columns={this.productTableColumns}
          expander
          defaultPageSize={5}
          defaultSorted={this.defaultSortedProducts}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                style: {
                  color: (parseFloat(rowInfo.original.available || 0) + parseFloat(rowInfo.original.allocatedQuantity))
                    < parseFloat(rowInfo.original.quantity)
                    ? 'red' : 'black',
                },
              };
            }
            return {};
          }}
        />
        {(showModalPendingAllocation
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.allocateOrder(selectedIds)}
              onCancel={() => this.setState({ showModalPendingAllocation: false })}
            >
              {I18n.t('BEE2957', { 0: selectedIds.length } /* Foram selecionado(s) %{0} documento(s) */)}
            </SweetAlert>
          )
        )}
        {(showModalAllocationFailure && (
          <ModalAllocationFailureReason
            openModal={showModalAllocationFailure}
            allocationResult={allocationFailureResult}
            isSimulation={isSimulationAllocation}
            closeModalAllocationFailureReason={this.closeModalAllocationFailureReason}
          />
        ))}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getDataGrid: (tableParams) => dispatch(getDataGrid(tableParams)),
  getDataGridIds: (tableParams) => dispatch(getDataGridIds(tableParams)),
  allocateProducts: (
    outboundOrderId,
    outboundProductId,
    isSimulation,
  ) => dispatch(allocateProducts(outboundOrderId, outboundProductId, isSimulation)),
});

export default connect(undefined, mapDispatchToProps)(withRouter(List));
